import { useCartTotal } from '@/js/vue/composable/cart-total.ts';

const ITEM_SELECTOR = '.js-add-cart-item';
const buttonElements = document.querySelectorAll<HTMLButtonElement>(ITEM_SELECTOR);

export async function initCartItems() {
  const { addProductItem } = useCartTotal();
  for (const buttonElement of buttonElements) {
  // eslint-disable-next-line ts/no-misused-promises
    buttonElement.addEventListener('click', async () => {
      const productId = buttonElement.dataset.productId ?? null;
      if (productId !== null) {
        await addProductItem(Number(productId), 1);
      }
    });
  }
}
